export { default } from './GamesLayout';
